package link.erpango.quip.data.remote

import io.ktor.client.HttpClient
import link.erpango.quip.data.remote.ktor.IHttpClientManager

actual class HttpClientFactory {
    actual fun createClient(httpClientManager: IHttpClientManager): HttpClient {
        return HttpClient {
            httpClientManager.createHttpClientConfig().invoke(this)
        }
    }
}
